var _rect, _rect2, _ellipse, _path, _rect3, _rect4, _rect5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrontside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 67,
    rx: 4,
    fill: "#CBCBCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 17.729,
    width: 30.462,
    height: 30.629,
    rx: 3,
    fill: "#F7F7F7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.962,
    cy: 27.3,
    rx: 5.712,
    ry: 5.743,
    fill: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.538 41.657c0-3.68 2.983-6.7 6.663-6.7l4.76 6.7 4.76-6.7c3.68 0 6.663 3.02 6.663 6.7v.872a2 2 0 01-2 2H21.538a2 2 0 01-2-2v-.872z",
    fill: "#CBCBCB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.52,
    y: 19.643,
    width: 28.558,
    height: 3.829,
    rx: 1.914,
    fill: "#F7F7F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.52,
    y: 31.129,
    width: 28.558,
    height: 3.829,
    rx: 1.914,
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.52,
    y: 42.614,
    width: 28.558,
    height: 3.829,
    rx: 1.914,
    fill: "#F7F7F7"
  })));
}

export default SvgFrontside;